<h2 mat-dialog-title>{{'COCKPIT.SELECT_SUPERCONTEXT_CTXS' | translate}}</h2>

<div mat-dialog-content>

  <p class="loading-row" *ngIf="loading">{{'loading' | translate}}...</p>

  <form [formGroup]="form" class="user-settings-form">

    <mat-form-field class="w-100" appearence="outline">
      <mat-label>{{'COCKPIT.TITLE_1' | translate}}</mat-label>
      <mat-select formControlName="contexts" multiple (closed)="onClosed()">
        <mat-option>
          <ngx-mat-select-search
            [formControl]="contextFilterCtrl"
            placeholderLabel="{{'search' | translate}}..."
            noEntriesFoundLabel="{{'no_results' | translate}}">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let co of filteredContexts" [value]="co.data.identifier" [disabled]="co.disabled">{{ co?.data?.contextName ? co.data.contextName : (co?.data?.name ? co.data.name : co?.data?.email) }}</mat-option>
      </mat-select>
    </mat-form-field>


  </form>
</div>

<div mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()" class="second-btn">{{'cancel' | translate}}</button>
  <button
    mat-raised-button
    class="first-btn"
    type="button"
    [disabled]="!form || form.invalid || saving || form.get('contexts').value?.length === 0"
    (click)="save()">
    {{'FORM.BTN_SAVE' | translate}}
  </button>
</div>
